export const CONTENTFUL_LOCALES = ['en', 'fr', 'nl'] as const;
export const NEXT_LOCALES = ['en', 'fr', 'nl'] as const;
export const COUNTRY_LOCALES = ['en-GB', 'fr-FR', 'nl-BE'] as const;
export const ELASTIC_LOCALES = ['en', 'fr', 'nl'] as const;
export const IXPOLE_LOCALES = ['en', 'fr', 'nl'] as const;

export type ContentfulLocale = typeof CONTENTFUL_LOCALES[number];
export type NextLocale = typeof NEXT_LOCALES[number];
export type CountryLocale = typeof COUNTRY_LOCALES[number];
export type ElasticLocale = typeof ELASTIC_LOCALES[number];
export type IxpoleLocale = typeof IXPOLE_LOCALES[number];

export type Localized<
    TType,
    TLocalization extends string = ContentfulLocale
> = {
    [key in TLocalization]: TType;
};
